import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import routes from "@/routes";

import { Flex, Typography, Spin, App, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import TabularFormFieldsTable from "@/components/tables/TabularFormFieldsTable";

import { getItem } from "@/api/definitions";

import { MODAL_TITLES } from "@/constants/definitions";

const { Title } = Typography;

const TabularFormView = () => {
  const { id, type } = useParams();
  const { message } = App.useApp();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  // initial fetch
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id, type]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await getItem(id);
      setData(data);
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async () => {
    try {
      const data = await getItem(id);
      setData(data);
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Flex vertical gap={30}>
            <Link
              to={routes.administration.resourcesSettings.structures.definitionDetail(
                type,
                id
              )}
            >
              <Space>
                <ArrowLeftOutlined />
                <span>Назад в {MODAL_TITLES[type]}</span>
              </Space>
            </Link>

            {data && (
              <Flex gap={20} vertical>
                <Title level={2} className="no-margin">
                  Настройка отображения табличной формы «{data.name}»
                </Title>

                <TabularFormFieldsTable
                  data={data.tableForm?.fields || []}
                  pagination={false}
                  onFieldChange={handleEdit}
                />
              </Flex>
            )}
          </Flex>
        </>
      )}
    </>
  );
};

export default TabularFormView;
